/** Shared es-MX defaults for all storefront tenants (cart, checkout, portal, etc.). */
export const ES_MX_STOREFRONT_COPY = {
  common: {
    brandFallback: "Tienda",
    headerTagline: "Productos y servicio premium",
    catalog: "Catálogo",
    cart: "Carrito",
    checkout: "Pago",
    searchPlaceholder: "Buscar productos...",
    browseCatalog: "Ver catálogo",
    seeProcess: "Ver proceso",
    signIn: "Iniciar sesión",
    continue: "Continuar",
    account: "Cuenta",
    portal: "Portal",
    signOut: "Cerrar sesión",
    loading: "Cargando...",
    unavailable: "No disponible",
    supportName: "Soporte",
    footerRights: "Todos los derechos reservados.",
    back: "Atrás",
  },
  home: {
    eyebrow: "Catálogo premium",
    heroTitle: "Encuentra el producto correcto con información clara.",
    heroSubtitle:
      "Consulta productos, compara detalles y crea pedidos desde una tienda configurada para esta empresa.",
    featureOneTitle: "Proceso visible",
    featureOneText:
      "Explica cómo se preparan, revisan y respaldan los productos.",
    featureTwoTitle: "Confianza en el producto",
    featureTwoText:
      "Muestra el trabajo detrás de cada producto antes del pago.",
    featureThreeTitle: "Soporte después de la compra",
    featureThreeText:
      "Conecta el proceso de la tienda con cuenta, devoluciones y soporte.",
    processTitle: "Cómo funciona el proceso.",
    processSubtitle:
      "Usa esta área para explicar cómo tu equipo prepara productos, verifica detalles y da soporte al cliente.",
    processStepOneTitle: "Preparar",
    processStepOneText:
      "Describe cómo se inspeccionan, seleccionan, construyen o preparan los productos.",
    processStepTwoTitle: "Verificar",
    processStepTwoText:
      "Explica cómo se revisan especificaciones, aplicación, calidad o disponibilidad.",
    processStepThreeTitle: "Entregar",
    processStepThreeText:
      "Describe expectativas de envío, recolección, instalación o entrega.",
    processStepFourTitle: "Soporte",
    processStepFourText:
      "Explica seguimiento, devoluciones, garantía o soporte después de la compra.",
    trustStatQc: "Calidad",
    trustStatCore: "Core",
    trustStatWarranty: "Garantía",
    trustStatSupport: "Soporte",
  },
  catalog: {
    title: "Encuentre el producto correcto.",
    subtitle:
      "Busque, filtre y compare productos disponibles en esta tienda.",
    emptyTitle: "No se encontraron productos",
    emptyText: "Intente ajustar su búsqueda o filtros.",
    available: "Disponible",
    productStatusFallback: "Artículo de catálogo",
    skuPrefix: "SKU",
    priceQuote: "Cotización",
    addToCart: "Agregar al carrito",
    addedToCart: "Agregado al carrito",
    inCart: "En carrito",
  },
  product: {
    backToCatalog: "Volver al catálogo",
    details: "Detalles",
    specifications: "Especificaciones",
    addToCart: "Agregar al carrito",
    checkout: "Pagar",
    alreadyInCart: "en el carrito",
    coreCharge: "Depósito de core",
    productFallback: "Producto",
    footerCatalog: "Catálogo",
  },
  cart: {
    title: "Carrito",
    emptyTitle: "Su carrito está vacío",
    emptyText: "Agregue productos del catálogo para iniciar un pedido.",
    total: "Total del carrito",
    checkout: "Pagar",
    signInRequired: "El pago requiere iniciar sesión con una cuenta de cliente.",
    refundableDeposit: "El depósito es reembolsable después de la devolución y aprobación.",
  },
  checkout: {
    title: "Pago",
    shipping: "Envío",
    payment: "Pago",
    placeOrder: "Realizar pedido",
    needInvoice: "¿Necesita datos de facturación?",
    requiredFields: "Faltan campos obligatorios.",
  },
  auth: {
    signInTitle: "Iniciar sesión",
    registerTitle: "Crear cuenta",
    customerAccount: "Cuenta de cliente",
    distributorAccount: "Cuenta de distribuidor",
    email: "Correo electrónico",
    password: "Contraseña",
  },
  portal: {
    customerPortal: "Portal de clientes",
    distributorPortal: "Portal de distribuidores",
    accountTools: "Herramientas de cuenta",
    distributorTools: "Herramientas de distribuidor",
    accountToolsDescription:
      "Pedidos, artículos registrados, perfil, facturas y direcciones.",
    distributorToolsDescription:
      "Pedidos, artículos registrados, perfil y direcciones.",
    accountHome: "Cuenta",
    registeredUnits: "Artículos registrados",
    coreReturns: "Devolución de cores",
    returnCore: "Devolver core",
    open: "Abrir",
    viewOnlyNotice:
      "Algunas acciones están ocultas porque su membresía es solo lectura.",
    orders: "Pedidos",
    profile: "Perfil",
    profileBilling: "Perfil / Facturación",
    addresses: "Direcciones",
    deleteAccount: "Eliminar cuenta",
    browseCatalog: "Ver catálogo",
  },
  orders: {
    title: "Pedidos",
    subtitle: "Rastree pedidos y documentos.",
    recentOrders: "Pedidos recientes",
    noOrders: "Aún no hay pedidos.",
    viewAll: "Ver todos los pedidos",
  },
  profile: {
    title: "Perfil",
    subtitle: "Preferencias de cuenta y facturación.",
    invoicePreferences: "Preferencias de facturación",
    invoiceDescription: "Información fiscal para el pago.",
    missingTaxFields: "Faltan campos fiscales obligatorios para el pago:",
    deleteRequestText:
      "Esto envía una solicitud verificada de eliminación. La revisaremos y daremos seguimiento por correo.",
  },
  addresses: {
    title: "Direcciones",
    subtitle: "Administre direcciones de envío y facturación.",
  },
  registeredUnits: {
    title: "Artículos registrados",
    subtitle: "Rastree productos registrados, devoluciones y garantías.",
    fallbackName: "Artículo registrado",
    open: "Abrir artículos registrados",
    scanTitle: "Escanear",
  },
  coreReturn: {
    title: "Devolver core",
    subtitle: "Envíe una solicitud de devolución para este artículo.",
    wizardSubtitle: "Confirme, empaque y luego imprima su etiqueta prepaga.",
    hubTitle: "Devolución de cores",
    hubSubtitle:
      "Devuelva cores adeudados con una etiqueta prepaga en tres pasos.",
    hubEmpty: "No tiene cores adeudados ni devoluciones activas por ahora.",
    owedSection: "Cores que adeuda",
    activeSection: "En progreso",
    noOwed: "No hay cores adeudados actualmente.",
    openReturn: "Abrir devolución",
    awaitingLabel: "Esperando etiqueta",
    backToHub: "Todas las devoluciones",
    creditLabel: "Crédito reembolsable",
    deadlineLabel: "Fecha límite",
    pendingQty: "Cantidad pendiente",
    serialPending: "Serie pendiente",
    loading: "Cargando devoluciones de cores...",
    loadError: "No se pudieron cargar las devoluciones de cores.",
    notFound: "No se pudo cargar este cuerpo de válvulas.",
    membershipBlocked:
      "Su membresía no permite iniciar devoluciones de cores.",
    confirmTitle: "Confirme este core",
    confirmSubtitle:
      "Está devolviendo este core con una etiqueta prepaga de VBS.",
    packTitle: "Empaque el core",
    packSubtitle:
      "Siga estos pasos para que el aceite no se derrame en el envío.",
    packComplete:
      "Empaque confirmado. Elija dónde entregar su core.",
    continueToLabel: "Continuar a la etiqueta",
    saving: "Guardando...",
    startError: "No se pudo iniciar la devolución del core.",
    notes: "Notas",
    photos: "Fotos de la devolución (opcional)",
    checklistRequired: "Confirme todos los puntos de empaque antes de continuar.",
    shipTitle: "Elija dónde depositar",
    shipSubtitle:
      "Opciones prepagadas — sin costo para usted. Elija paquetería y una sucursal cercana para dejar el paquete con etiqueta.",
    labelReadyTitle: "Su etiqueta está lista",
    labelReadySubtitle:
      "Imprima la etiqueta prepaga y deposite el core empacado en la sucursal.",
    labelReadyMessage: "Su etiqueta de devolución prepaga está lista.",
    printLabel: "Imprimir etiqueta",
    trackReturn: "Rastrear devolución",
    refreshOptions: "Actualizar opciones",
    retryOptions: "Reintentar opciones de envío",
    loadingOptions: "Cargando opciones prepagadas...",
    optionsError: "No se pudieron cargar las opciones de envío prepago.",
    noOptions: "No hay opciones prepaga para depositar el paquete ahora.",
    bookError: "No se pudo generar la etiqueta de devolución.",
    generatingLabel: "Generando etiqueta...",
    modeDropoff: "Imprimir etiqueta y depositar",
    modePickup: "Recolección + etiqueta prepaga",
    deliveryDays: "Estimado de {days} días",
    dropOffTitle: "Sucursales cercanas para depositar",
    dropOffTitleForCarrier: "Sucursales {carrier} cercanas para depositar",
    dropOffEmpty:
      "No se encontraron sucursales cercanas para depositar con esta paquetería. Use el localizador del sitio después de imprimir su etiqueta.",
    openMap: "Abrir mapa",
    timelineTitle: "Progreso de la devolución",
    refundText:
      "Cuando la devolución se reciba, inspeccione y apruebe, se reembolsará el monto elegible.",
    sealedLabel: "El artículo está sellado en el empaque incluido.",
    checklist: {
      oil: "La caja no está goteando ni filtrando aceite.",
      box: "La devolución usa la caja original o anterior.",
    },
    steps: {
      confirm: "1. Confirmar",
      pack: "2. Empacar",
      ship: "3. Imprimir etiqueta",
    },
    instructions: {
      oilTitle: "Drene todo el aceite",
      oilBody:
        "Drene el core por completo. Limpie residuos para que la caja no gotee ni filtre aceite.",
      bagTitle: "Séllelo en una bolsa de plástico",
      bagBody:
        "Coloque el core en la bolsa de plástico incluida y séllela antes de empacarlo.",
      boxTitle: "Use la caja original",
      boxBody:
        "Empaque el core embolsado en la caja original o anterior para un envío seguro.",
    },
    status: {
      owed: "Core pendiente",
      started: "Devolución iniciada",
      labelReady: "Etiqueta lista",
      inTransit: "En tránsito",
      received: "Recibido",
      inspection: "Inspección de almacén",
      approved: "Aprobado",
      forfeited: "Perdido",
      none: "Sin devolución activa",
    },
    timeline: {
      started: "Devolución iniciada",
      label: "Etiqueta lista",
      transit: "En tránsito",
      received: "Recibido / inspección",
      approved: "Aprobado",
    },
  },
  warranty: {
    title: "Garantía",
    subtitle: "Inicie y dé seguimiento a reclamos de garantía.",
    activeClaim: "Ya hay un reclamo activo abierto.",
    returnShipping: "Envío de devolución",
    inspectionUpdates:
      "Las actualizaciones de inspección aparecen aquí cuando se reciba el artículo devuelto.",
  },
  support: {
    title: "Soporte",
    subtitle: "Escriba a soporte y comparta imágenes del reclamo.",
    staffName: "Soporte",
    you: "Usted",
  },
  legal: {
    privacyTitle: "Aviso de privacidad",
    deleteTitle: "Eliminar cuenta",
    privacyIntro:
      "Este aviso explica cómo esta tienda recopila, usa, comparte y protege la información de clientes.",
    deleteIntro:
      "Puede solicitar la eliminación de su cuenta de cliente o distribuidor desde el portal.",
    appInstruction: "Inicie sesión en su cuenta de cliente o distribuidor.",
    retainedRecords:
      "Registros de pedidos, devoluciones, garantía, soporte y prevención de fraude.",
    verificationText:
      "Podemos contactarle desde un correo oficial si se requiere verificación adicional.",
  },
};
